import { render, staticRenderFns } from "./ProjectSepticSubmissionForm.vue?vue&type=template&id=24211644"
import script from "./ProjectSepticSubmissionForm.vue?vue&type=script&lang=js"
export * from "./ProjectSepticSubmissionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports